/**
 * Constantes del Laboratorio EVSE (TG-97).
 *
 * La allowlist del VCP (`VCP_ALLOWED_STATIONS`) NO se replica aquí: la informa
 * el backend en `GET /api/v1/noc/sim/config` para no tener dos fuentes de verdad.
 */

/** Estados OCPP 1.6J para `StatusNotification` (inyección). */
export const INJECTABLE_STATUSES = [
  'Available',
  'Preparing',
  'Charging',
  'SuspendedEV',
  'SuspendedEVSE',
  'Finishing',
  'Reserved',
  'Unavailable',
  'Faulted',
] as const;

/** Códigos de error OCPP 1.6J habituales. */
export const INJECTABLE_ERROR_CODES = [
  'NoError',
  'GroundFailure',
  'OverCurrentFailure',
  'OverVoltage',
  'UnderVoltage',
  'WeakSignal',
  'OtherError',
] as const;

/** Mensajes soportados por `triggerMessage` (downlink). */
export const TRIGGER_MESSAGES = [
  'MeterValues',
  'StatusNotification',
  'BootNotification',
  'Heartbeat',
  'DiagnosticsStatusNotification',
  'FirmwareStatusNotification',
] as const;

/** Tipos de `reset` OCPP. */
export const RESET_TYPES = ['Immediate', 'Soft', 'Hard'] as const;

/** Perfil DLM 1.6J determinista (16 A) usado como preset por la UI. */
export function buildChargingProfile(limitA: number): Record<string, unknown> {
  return {
    chargingProfileId: 101,
    stackLevel: 0,
    chargingProfilePurpose: 'TxDefaultProfile',
    chargingProfileKind: 'Recurring',
    recurrencyKind: 'Daily',
    chargingSchedule: {
      chargingRateUnit: 'A',
      chargingSchedulePeriod: [{ startPeriod: 0, limit: limitA }],
    },
  };
}
